import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
const WithoutAuth = () => {
    const token = useSelector(state => state?.userData?.access_token);
    const location = useLocation();

    const urlParams = new URLSearchParams(location.search);
    const redirect_url = urlParams.get("redirect_url");

    if (token && redirect_url) {
        return <Navigate to={redirect_url} replace />;
    }

    if (token) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
export default WithoutAuth;